<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import { CtaModel, NavItem } from '@centerhealth/fe/center-kit';
  import { Button } from '@centerhealth/fe/center-kit';

  const dispatch = createEventDispatcher();

  export let navItems: NavItem[] = [];
  export let cta: CtaModel = null;

  // Custom listener event for in and outside clicks
  export const clickListener = (node: HTMLElement): { destroy: () => void } => {
    const handleClick = (event: { target: Node; defaultPrevented: unknown } | MouseEvent) => {
      const targetEvent = event as { target: Node; defaultPrevented: unknown };
      if (node && !node.contains(targetEvent.target) && !event.defaultPrevented) {
        node.dispatchEvent(new CustomEvent('click-listener', node as CustomEventInit<unknown>));
      }
    };

    document.addEventListener('click', handleClick, true);

    return {
      destroy() {
        document.removeEventListener('click', handleClick, true);
      },
    };
  };
</script>

<nav class="mobile-nav" use:clickListener on:click-listener>
  <ul>
    {#each navItems as { name, link, active }}
      <li class="flex text-gray-darkest" on:click={() => dispatch('click-listener')}>
        <a href={link} class:active={active === true}>{name}</a>
      </li>
    {/each}
    {#if cta}
      <li>
        {#if cta.link.includes('subscribe')}
          <li
            class="flex justify-center text-white py-24"
            on:click={() => dispatch('click-listener')}
          >
            <Button
              heapAttr={{
                action: 'cta',
                subAction: 'subscribe',
                sectionName: 'nav',
              }}
              href={cta.link}
              size="small">{cta.label}</Button
            >
          </li>
        {:else}
          <li
            class="flex justify-center text-white py-24"
            on:click={() => dispatch('click-listener')}
          >
            <Button
              heapAttr={{
                action: 'cta',
                subAction: 'signup',
                sectionName: 'nav',
              }}
              href={cta.link}
              size="small">{cta.label}</Button
            >
          </li>
        {/if}
      </li>{/if}
  </ul>
</nav>

<style>
  .mobile-nav {
    @apply bg-white ease-in-out delay-1000 w-[300px] absolute right-0 rounded-2xl drop-shadow-md;
    margin: 0px 0 -10px 0;
  }

  .mobile-nav ul li:nth-child(1) a.active {
    @apply text-white rounded-t-2xl;
    background-color: #2ecc71;
  }

  .mobile-nav ul li:nth-child(2) a.active {
    @apply text-white;
    background-color: #9c88ff;
  }

  .mobile-nav ul li:nth-child(3) a.active {
    @apply text-white;
    background-color: #e74c3c;
  }

  .mobile-nav ul li:nth-child(4) a.active {
    @apply text-white;
    background-color: #f39c12;
  }

  .mobile-nav ul {
    font-size: 18px;
    font-weight: 600;
  }

  .mobile-nav ul a {
    padding: 20px;
    width: 100%;
    text-align: center;
  }
</style>
